'use strict';

angular.module('licensure.services')
    .factory('InspectionAutoNumbers', ['$http', '$q', function ($http, $q) {
        return {
            get: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/InspectionAutoNumbers', {
                        params: {
                        
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            save: function (auto_number) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/InspectionAutoNumbers/';
                if (!isUndefined(auto_number.id)) {
                    method = 'PUT'
                    url += auto_number.id
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        auto_number: auto_number
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;